module.exports = __webpack_public_path__ + "static/media/Tulip.c0d9f382.png";